module.exports = __webpack_public_path__ + "img/all_view.90970058.png";